import React, { useRef, useState, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonGrid, IonRow, IonCol, useIonToast, IonLabel, IonItem, IonSelect, IonSelectOption, IonInput } from '@ionic/react';
import { close } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { useForceUpdate } from '../../../defines/Functions';
import { ConvertToEnDigit } from '../../../defines/Functions';
import axios from "axios";
import Loading from '../../Loading';
import moment from 'jalali-moment';
import './ProfileOrderAmendment.css';

interface Props {
    data: any,
    type: any
}
const ProfileOrderAmendment = (props: Props) => {
    const profileOrderMaster = Constants.api.profileOrderMaster;
    const profileOrderAmendment = Constants.api.profileOrderAmendment;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        });
    };
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [state, setState] = useState({
        showProfileOrderAmendmentModal: false,
        token: '',
        amendment_all_passengers_has_requested: false
    });
    const [itineraries, setItineraries] = useState([]) as any;
    const forceUpdate = useForceUpdate();
    const [amendmentData, setAmendmentData] = useState({
        passengers: [] as any,
        passengers_ids: [] as any
    });
    const [formData, setFormData] = useState({
        gender: 'm',
        first_name: '',
        last_name: '',
        sheba: ''
    });
    const [required, setRequired] = useState({
        first_name: { value: false, message: '' },
        last_name: { value: false, message: '' },
        sheba: { value: false, message: '' }
    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const getContract = async (contractId: number) => {
        setLoading(true);
        if (contractId) {
            var xmlData = '<OTA_ReadRQ><UniqueID ID="' + contractId + '" /></OTA_ReadRQ>';
            try {
                const amendmentResults = await axios.post(profileOrderMaster, xmlData, {
                    headers: {
                        Authorization: 'Bearer ' + state.token,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                var data = amendmentResults.data;
                if (data.items) {
                    if (data.items.hasOwnProperty('success')) {
                        if (props.data.type === 'flight') {
                            if (data.items.reservationsList && data.items.reservationsList.airReservation.length) {
                                let air_items_array = [] as any;
                                let passengers_count = 0;
                                let passengers_cancel_requests_count = 0;
                                let flight_direction = props.data.direction_ind;
                                let grouped_legs_leg_1 = [] as any;
                                let grouped_legs_leg_2 = [] as any;
                                let ticket_canceled_requests = [] as any;
                                ticket_canceled_requests = data.items.cancel_history;
                                data.items.reservationsList.airReservation.forEach((air_item: any) => {
                                    air_item.has_amendments = false;
                                    if (air_item.flightSegment.departureDateTime) {
                                        let departure_datetime = moment(air_item.flightSegment.departureDateTime).format('YYYY-MM-DD HH:mm');
                                        let now_datetime = moment().format('YYYY-MM-DD HH:mm');
                                        var flight_1_diff = moment(departure_datetime).diff(now_datetime);
                                        if (flight_1_diff >= 0) {
                                            air_item.has_amendments = true;
                                        }
                                    }
                                    let air_travelers_array = [] as any;
                                    if (flight_direction === 'Roundtrip') {
                                        if (air_item.itineraryName === '1') {
                                            grouped_legs_leg_1.push(air_item);
                                        }
                                        if (air_item.itineraryName === '2') {
                                            grouped_legs_leg_2.push(air_item);
                                        }
                                    } else {
                                        air_item.travelerName.forEach((traveler_item: any) => {
                                            passengers_count++;
                                            let passenger_id = '';
                                            passenger_id += air_item.flightSegment.departureAirport.locationCode + '-';
                                            passenger_id += air_item.flightSegment.arrivalAirport.locationCode + '-';
                                            passenger_id += traveler_item.document.docID;
                                            traveler_item.passenger_id = passenger_id;
                                            let index = ticket_canceled_requests.findIndex((record: any) => record.passenger_info === passenger_id);
                                            if (index === -1) {
                                                traveler_item.amendment_info = null;
                                            } else {
                                                passengers_cancel_requests_count++;
                                                traveler_item.amendment_info = ticket_canceled_requests[index];
                                            }
                                            air_travelers_array.push(traveler_item);
                                        });
                                        air_item.travelerName = air_travelers_array;
                                        air_items_array.push(air_item);
                                    }
                                });
                                if (flight_direction !== 'Roundtrip') {
                                    if (passengers_cancel_requests_count === passengers_count) {
                                        setState({ ...state, amendment_all_passengers_has_requested: true });
                                    }
                                    setItineraries(air_items_array);
                                } else {
                                    let itinerariesArr = [] as any;
                                    let grouped_passenges_leg_1 = {} as any;
                                    let grouped_passenges_leg_2 = {} as any;
                                    if (grouped_legs_leg_1.length !== 0) {
                                        grouped_legs_leg_1.forEach((air_item: any) => {
                                            air_item.travelerName.forEach((traveler_item: any) => {
                                                if (typeof grouped_passenges_leg_1[traveler_item.document.docID] === 'undefined') {
                                                    grouped_passenges_leg_1[traveler_item.document.docID] = [];
                                                }
                                                let traveler_element = {} as any;
                                                traveler_element.traveler_info = traveler_item;
                                                traveler_element.flight_info = air_item;
                                                grouped_passenges_leg_1[traveler_item.document.docID].push(traveler_element);

                                            });
                                        });
                                        Object.values(grouped_passenges_leg_1).forEach((passenger_item: any) => {
                                            passengers_count++;
                                            let flights_count = passenger_item.length;
                                            let flight_first_idx = 0;
                                            let flight_last_idx = flights_count - 1;
                                            let itineraries_item = {} as any;
                                            itineraries_item.flight = {};
                                            itineraries_item.flight.from = {};
                                            itineraries_item.flight.from.code = passenger_item[flight_first_idx].flight_info.flightSegment.departureAirport.locationCode;
                                            itineraries_item.flight.from.title = passenger_item[flight_first_idx].flight_info.flightSegment.departureAirport.codeContext;
                                            itineraries_item.flight.to = {};
                                            itineraries_item.flight.to.code = passenger_item[flight_last_idx].flight_info.flightSegment.arrivalAirport.locationCode;
                                            itineraries_item.flight.to.title = passenger_item[flight_last_idx].flight_info.flightSegment.arrivalAirport.codeContext;
                                            itineraries_item.flight.numbers = [];
                                            itineraries_item.flight.unique_id = itineraries_item.flight.from.code + '-' + itineraries_item.flight.to.code;
                                            let traveler_item = passenger_item[flight_first_idx].traveler_info;
                                            traveler_item.has_amendments = false;
                                            if (passenger_item[flight_first_idx].flight_info.flightSegment.departureDateTime) {
                                                let departure_datetime = moment(passenger_item[flight_first_idx].flight_info.flightSegment.departureDateTime).format('YYYY-MM-DD HH:mm');
                                                let now_datetime = moment().format('YYYY-MM-DD HH:mm');
                                                var flight_1_diff = moment(departure_datetime).diff(now_datetime);
                                                if (flight_1_diff >= 0) {
                                                    traveler_item.has_amendments = true;
                                                }
                                            }
                                            let passenger_id = 'ROUNDTRIP-';
                                            passenger_id += itineraries_item.flight.from.code + '-';
                                            passenger_id += itineraries_item.flight.to.code + '-';
                                            passenger_id += traveler_item.document.docID;
                                            traveler_item.passenger_id = passenger_id;
                                            let index = ticket_canceled_requests.findIndex((record: any) => record.passenger_info === passenger_id);
                                            if (index === -1) {
                                                traveler_item.amendment_info = null;
                                            } else {
                                                passengers_cancel_requests_count++;
                                                traveler_item.amendment_info = ticket_canceled_requests[index];
                                            }
                                            let exist_index = itineraries.findIndex((record: any) => record.flight.unique_id === itineraries_item.flight.unique_id);
                                            if (exist_index === -1) {
                                                itineraries_item.passengers = [];
                                                itineraries_item.passengers.push(traveler_item);
                                                passenger_item.forEach((leg_item: any) => {
                                                    itineraries_item.flight.numbers.push(leg_item.flight_info.flightSegment.flightNumber);
                                                });
                                                itinerariesArr.push(itineraries_item);
                                                setItineraries(itinerariesArr);
                                            } else {
                                                itinerariesArr[exist_index].passengers.push(traveler_item);
                                                setItineraries(itinerariesArr);
                                            }
                                        });
                                    }
                                    if (grouped_legs_leg_2.length !== 0) {
                                        grouped_legs_leg_2.forEach((air_item: any) => {
                                            air_item.travelerName.forEach((traveler_item: any) => {
                                                if (typeof grouped_passenges_leg_2[traveler_item.document.docID] === 'undefined') {
                                                    grouped_passenges_leg_2[traveler_item.document.docID] = [];
                                                }
                                                let traveler_element = {} as any;
                                                traveler_element.traveler_info = traveler_item;
                                                traveler_element.flight_info = air_item;
                                                grouped_passenges_leg_2[traveler_item.document.docID].push(traveler_element);

                                            });
                                        });
                                        Object.values(grouped_passenges_leg_2).forEach((passenger_item: any) => {
                                            passengers_count++;
                                            let flights_count = passenger_item.length;
                                            let flight_first_idx = 0;
                                            let flight_last_idx = flights_count - 1;
                                            let itineraries_item = {} as any;
                                            itineraries_item.flight = {};
                                            itineraries_item.flight.from = {};
                                            itineraries_item.flight.from.code = passenger_item[flight_first_idx].flight_info.flightSegment.departureAirport.locationCode;
                                            itineraries_item.flight.from.title = passenger_item[flight_first_idx].flight_info.flightSegment.departureAirport.codeContext;
                                            itineraries_item.flight.to = {};
                                            itineraries_item.flight.to.code = passenger_item[flight_last_idx].flight_info.flightSegment.arrivalAirport.locationCode;
                                            itineraries_item.flight.to.title = passenger_item[flight_last_idx].flight_info.flightSegment.arrivalAirport.codeContext;
                                            itineraries_item.flight.numbers = [];
                                            itineraries_item.flight.unique_id = itineraries_item.flight.from.code + '-' + itineraries_item.flight.to.code;
                                            let traveler_item = passenger_item[flight_first_idx].traveler_info;
                                            traveler_item.has_amendments = false;
                                            if (passenger_item[flight_first_idx].flight_info.flightSegment.departureDateTime) {
                                                let departure_datetime = moment(passenger_item[flight_first_idx].flight_info.flightSegment.departureDateTime).format('YYYY-MM-DD HH:mm');
                                                let now_datetime = moment().format('YYYY-MM-DD HH:mm');
                                                var flight_1_diff = moment(departure_datetime).diff(now_datetime);
                                                if (flight_1_diff >= 0) {
                                                    traveler_item.has_amendments = true;
                                                }
                                            }
                                            let passenger_id = 'ROUNDTRIP-';
                                            passenger_id += itineraries_item.flight.from.code + '-';
                                            passenger_id += itineraries_item.flight.to.code + '-';
                                            passenger_id += traveler_item.document.docID;
                                            traveler_item.passenger_id = passenger_id;
                                            let index = ticket_canceled_requests.findIndex((record: any) => record.passenger_info === passenger_id);
                                            if (index === -1) {
                                                traveler_item.amendment_info = null;
                                            } else {
                                                passengers_cancel_requests_count++;
                                                traveler_item.amendment_info = ticket_canceled_requests[index];
                                            }
                                            let exist_index = itineraries.findIndex((record: any) => record.flight.unique_id === itineraries_item.flight.unique_id);
                                            if (exist_index === -1) {
                                                itineraries_item.passengers = [];
                                                itineraries_item.passengers.push(traveler_item);
                                                passenger_item.forEach((leg_item: any) => {
                                                    itineraries_item.flight.numbers.push(leg_item.flight_info.flightSegment.flightNumber);
                                                });
                                                itinerariesArr.push(itineraries_item);
                                                setItineraries(itinerariesArr);
                                            } else {
                                                itinerariesArr[exist_index].passengers.push(traveler_item);
                                                setItineraries(itinerariesArr);
                                            }
                                        });
                                    }
                                    if (passengers_cancel_requests_count === passengers_count) {
                                        setState(prevState => ({ ...prevState, amendment_all_passengers_has_requested: true }));
                                    }
                                }
                            } else {
                                showToast({
                                    message: 'بلیطی با این مشخصات یافت نشد',
                                    color: 'danger'
                                });
                            }
                        } else {
                            showToast({
                                message: 'بلیطی با این مشخصات یافت نشد',
                                color: 'danger'
                            });
                        }
                    } else {
                        showToast({
                            message: 'بلیطی با این مشخصات یافت نشد',
                            color: 'danger'
                        });
                    }
                } else {
                    showToast({
                        message: 'خطا در ارتباط با وب سرویس ، لطفاً مجددا تلاش کنید',
                        color: 'danger'
                    });
                }
                setLoading(false);
            } catch (error: any) {
                console.log(error);
                setLoading(false);
            }
        } else {
            showToast({
                message: 'بلیطی با این مشخصات یافت نشد',
                color: 'danger'
            });
        }
        setLoading(false);
    }
    useEffect(() => {
        if (state.showProfileOrderAmendmentModal) {
            getContract(props.data.contract_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showProfileOrderAmendmentModal]);
    const amendmentTicketSelectMultipleRoundtrip = (passenger: any, ticket: any, passengerIndex: number, ticketIndex: number) => {
        forceUpdate();
        let passenger_id = passenger.passenger_id;
        let index = amendmentData.passengers_ids.findIndex((record: any) => record === passenger_id);
        if (index === -1) {
            const itinerariesArr = itineraries;
            const amendmentDataArr = amendmentData;
            itinerariesArr[ticketIndex].passengers[passengerIndex].selected = true;
            passenger.selected = true;
            amendmentDataArr.passengers_ids.push(passenger_id);
            let record = {} as any;
            record.passenger_info = passenger;
            record.ticket_info = ticket.flight;
            record.passenger_id = passenger_id;
            amendmentDataArr.passengers.push(record);
            setAmendmentData(amendmentDataArr);
            setItineraries(itinerariesArr);
        }
    }
    const amendmentTicketDeselectMultipleRoundtrip = (passenger: any, ticket: any, passengerIndex: number, ticketIndex: number) => {
        forceUpdate();
        let passenger_id = passenger.passenger_id;
        let index = amendmentData.passengers_ids.findIndex((record: any) => record === passenger_id);
        if (index !== -1) {
            const itinerariesArr = itineraries;
            const amendmentDataArr = amendmentData;
            itinerariesArr[ticketIndex].passengers[passengerIndex].selected = false;
            passenger.selected = false;
            amendmentDataArr.passengers_ids.splice(index, 1);
            amendmentDataArr.passengers.splice(index, 1);
            setAmendmentData(amendmentDataArr);
            setItineraries(itinerariesArr);
        }
    }
    const amendmentTicketSelectMultiple = (passenger: any, ticket: any, passengerIndex: number, ticketIndex: number) => {
        forceUpdate();
        let passenger_id = ticket.flightSegment.departureAirport.locationCode + '-' + ticket.flightSegment.arrivalAirport.locationCode + '-' + passenger.document.docID;
        let index = amendmentData.passengers_ids.findIndex((record: any) => record === passenger_id);
        if (index === -1) {
            const itinerariesArr = itineraries;
            const amendmentDataArr = amendmentData;
            itinerariesArr[ticketIndex].travelerName[passengerIndex].selected = true;
            amendmentDataArr.passengers_ids.push(passenger_id);
            let ticket_info = {} as any;
            ticket_info.departureAirport = ticket.flightSegment.departureAirport;
            ticket_info.arrivalAirport = ticket.flightSegment.arrivalAirport;
            ticket_info.flightNumber = ticket.flightSegment.flightNumber;
            let record = {} as any;
            record.passenger_info = passenger;
            record.ticket_info = ticket_info;
            record.passenger_id = passenger_id;
            amendmentDataArr.passengers.push(record);
            setAmendmentData(amendmentDataArr);
            setItineraries(itinerariesArr);
        }
    }
    const amendmentTicketDeselectMultiple = (passenger: any, ticket: any, passengerIndex: number, ticketIndex: number) => {
        forceUpdate();
        let passenger_id = ticket.flightSegment.departureAirport.locationCode + '-' + ticket.flightSegment.arrivalAirport.locationCode + '-' + passenger.document.docID;
        let index = amendmentData.passengers_ids.findIndex((record: any) => record === passenger_id);
        if (index !== -1) {
            const itinerariesArr = itineraries;
            const amendmentDataArr = amendmentData;
            itinerariesArr[ticketIndex].travelerName[passengerIndex].selected = false;
            amendmentDataArr.passengers_ids.splice(index, 1);
            amendmentDataArr.passengers.splice(index, 1);
            setAmendmentData(amendmentDataArr);
            setItineraries(itinerariesArr);
        }
    }
    const checkViewStep2RowsRoundtrip = (ticket: any) => {
        let ticket_selected_passengers = 0;
        ticket.passengers.forEach((item: any) => {
            if (typeof item.selected !== "undefined") {
                if (item.selected) {
                    ticket_selected_passengers++;
                }
            }
        });
        if (ticket_selected_passengers === 0) {
            return false;
        } else {
            return true;
        }
    }
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (formData.first_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: false, message: '' } } });
        }
        if (formData.last_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: false, message: '' } } });
        }
        if (formData.sheba.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, sheba: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, sheba: { value: false, message: '' } } });
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (formData.first_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.last_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.sheba.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, sheba: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, sheba: { value: false, message: '' } } });
            isRequired = false;
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        let xmlData = '<OTA_CancelRQ CancelType="Initiate">';
        xmlData += '<UniqueID ID="' + props.data.contract_id + '" Type="ConnectOTA"/>';
        if (amendmentData.passengers.length > 1) {
            xmlData += '<OriginAndDestinationSegments>';
        }
        amendmentData.passengers.forEach((item: any) => {
            xmlData += '<OriginAndDestinationSegment>';
            if (props.data.direction_ind === 'Roundtrip') {
                xmlData += '<OriginLocation LocationCode="' + item.ticket_info.from.code + '"/>';
                xmlData += '<DestinationLocation LocationCode="' + item.ticket_info.to.code + '"/>';
            } else {
                xmlData += '<OriginLocation LocationCode="' + item.ticket_info.departureAirport.locationCode + '"/>';
                xmlData += '<DestinationLocation LocationCode="' + item.ticket_info.arrivalAirport.locationCode + '"/>';
            }
            xmlData += '<Traveler DocID=" ' + item.passenger_info.document.docID + '" DocType="' + item.passenger_info.document.docID + '">';
            xmlData += '<GivenName>' + item.passenger_info.givenName[0] + '</GivenName>';
            xmlData += '<Surname>' + item.passenger_info.surname + '</Surname>';
            xmlData += '<PassengerID>' + item.passenger_id + '</PassengerID>';
            xmlData += '</Traveler>';
            xmlData += '</OriginAndDestinationSegment>';
        })
        if (amendmentData.passengers.length > 1) {
            xmlData += '</OriginAndDestinationSegments>';
        }
        xmlData += '<Verification>';
        xmlData += '<PaymentCard>';
        xmlData += '<CardNumber>';
        xmlData += '<PlainText>' + ConvertToEnDigit(formData.sheba) + '</PlainText>';
        xmlData += '</CardNumber>';
        xmlData += '<CardHolderNameDetails>';
        xmlData += '<NamePrefix>' + formData.gender + '</NamePrefix>';
        xmlData += '<GivenName>' + formData.first_name + '</GivenName>';
        xmlData += '<Surname>' + formData.last_name + '</Surname>';
        xmlData += '</CardHolderNameDetails>';
        xmlData += '</PaymentCard>';
        xmlData += '</Verification>';
        xmlData += '</OTA_CancelRQ>';
        try {
            const formResults = await axios.post(profileOrderAmendment, xmlData, {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.result === 'error') {
                showToast({ message: formResults.data.message, color: 'danger' });
                setFormData({
                    gender: 'm',
                    first_name: '',
                    last_name: '',
                    sheba: ''
                });
                setLoading(false);
            } else {
                showToast({ message: formResults.data.message, color: 'success' });
                setFormData({
                    gender: 'm',
                    first_name: '',
                    last_name: '',
                    sheba: ''
                });
                setStep(1);
                getContract(props.data.contract_id);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    const onCloseModal = () => {
        setStep(1);
        setState({ ...state, showProfileOrderAmendmentModal: false });
    }
    return (
        <>
            <IonModal isOpen={state.showProfileOrderAmendmentModal} onDidDismiss={onCloseModal} mode="ios" cssClass="profile-order-amendment-modal">
                <div className="profile-order-amendment-modal-content">
                    <h3 className="profile-order-amendment-modal-title">
                        استرداد خرید شماره {props.data.contract_id}
                        <IonIcon icon={close} onClick={onCloseModal} />
                    </h3>
                    {!loading ?
                        step === 1 ?
                            <div className="profile-order-amendment-modal-items">
                                {!state.amendment_all_passengers_has_requested &&
                                    <div className="amendment-note">
                                        <p>
                                            كاربر گرامي جهت كنسل كردن پرواز خود ابتدا مسير و مسافر مورد نظر را انتخاب و در آخر بر روي درخواست استرداد كليك نماييد.
                                            <br />
                                            مدت زمان استرداد پروازهاي داخلي ٧٢ ساعت و پروازهاي خارجي ٧ روز كاري مي باشد.
                                        </p>
                                    </div>
                                }
                                {props.data.direction_ind === 'Roundtrip' ?
                                    itineraries.map((ticket: any, index: number) =>
                                        <React.Fragment key={"index" + index}>
                                            <div className="amendment-info">
                                                <div>
                                                    {index === 0 ?
                                                        ' پرواز رفت '
                                                        :
                                                        ' پرواز برگشت '
                                                    }
                                                    از
                                                    <span>({ticket.flight.from.code})</span>
                                                    به
                                                    <span>({ticket.flight.to.code})</span>
                                                </div>
                                                <div>
                                                    شماره پرواز (ها) :
                                                    <span>
                                                        {ticket.flight.numbers.join()}
                                                    </span>
                                                </div>
                                            </div>
                                            {ticket.passengers.map((traveler: any, travelerIndex: number) =>
                                                <div className="amendment-box" key={"index" + travelerIndex}>
                                                    <IonGrid>
                                                        <IonRow>
                                                            <IonCol size="6">
                                                                <b>نام و نام خانوادگی</b>
                                                                <span>
                                                                    {traveler.namePrefix[0].length ? traveler.namePrefix[0] + ' ' : ' '}
                                                                    {traveler.givenName[0] ? traveler.givenName[0] + ' ' : ' '}
                                                                    {traveler.middleName[0] ? traveler.middleName[0] + ' ' : ' '}
                                                                    {traveler.surname ? traveler.surname + ' ' : ' '}
                                                                </span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>شماره بلیط</b>
                                                                <span>{traveler.tpaextensions.any[0].eTicket}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>تاریخ تولد</b>
                                                                <span>{traveler.tpaextensions.any[0].birthDate}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                {traveler.document.docType === 5 ?
                                                                    <b>کد ملی</b>
                                                                    :
                                                                    <b>شماره پاسپورت</b>
                                                                }
                                                                <span>{traveler.document.docID}</span>
                                                            </IonCol>
                                                            {traveler.amendment_info === null ?
                                                                traveler.has_amendments ?
                                                                    <IonCol size="12">
                                                                        {!traveler.selected ?
                                                                            <IonButton
                                                                                color="warning" expand="block"
                                                                                onClick={() => amendmentTicketSelectMultipleRoundtrip(traveler, ticket, travelerIndex, index)}
                                                                            >
                                                                                انتخاب
                                                                            </IonButton>
                                                                            :
                                                                            <IonButton
                                                                                color="danger" expand="block"
                                                                                onClick={() => amendmentTicketDeselectMultipleRoundtrip(traveler, ticket, travelerIndex, index)}
                                                                            >
                                                                                لغو انتخاب
                                                                            </IonButton>
                                                                        }
                                                                    </IonCol>
                                                                    :
                                                                    <IonCol size="12">
                                                                        <IonButton color="dark" expand="block" disabled>زمان استرداد گذشته</IonButton>
                                                                    </IonCol>
                                                                :
                                                                <IonCol size="12">
                                                                    {traveler.amendment_info.status === 'r' ?
                                                                        <IonButton color="primary" expand="block" disabled>در حال بررسی استرداد</IonButton>
                                                                        : traveler.amendment_info.status === 'p' ?
                                                                            <IonButton color="danger" expand="block" disabled>پنالتی</IonButton>
                                                                            : traveler.amendment_info.status === 'c' ?
                                                                                <IonButton color="secondary" expand="block" disabled>ارسال شده به واحد مالی</IonButton>
                                                                                : traveler.amendment_info.status === 'd' ?
                                                                                    <IonButton color="success" expand="block" disabled>مبلغ استرداد شده</IonButton>
                                                                                    : traveler.amendment_info.status === 'j' ?
                                                                                        <IonButton color="medium" expand="block" disabled>غیر قابل استرداد</IonButton>
                                                                                        : traveler.amendment_info.status === 'expired' ?
                                                                                            <IonButton color="dark" expand="block" disabled>زمان استرداد گذشته</IonButton>
                                                                                            :
                                                                                            null
                                                                    }
                                                                </IonCol>
                                                            }
                                                        </IonRow>
                                                    </IonGrid>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )
                                    :
                                    itineraries.map((ticket: any, index: number) =>
                                        <React.Fragment key={"index" + index}>
                                            <div className="amendment-info">
                                                <div>
                                                    پرواز رفت از
                                                    <span>({ticket.flightSegment.departureAirport.locationCode})</span>
                                                    به
                                                    <span>({ticket.flightSegment.arrivalAirport.locationCode})</span>
                                                </div>
                                                <div>
                                                    شماره پرواز :
                                                    <span>
                                                        {ticket.flightSegment.flightNumber}
                                                    </span>
                                                </div>
                                            </div>
                                            {ticket.travelerName.map((traveler: any, travelerIndex: number) =>
                                                <div className="amendment-box" key={"index" + travelerIndex}>
                                                    <IonGrid>
                                                        <IonRow>
                                                            <IonCol size="6">
                                                                <b>نام و نام خانوادگی</b>
                                                                <span>
                                                                    {traveler.namePrefix[0].length ? traveler.namePrefix[0] + ' ' : ' '}
                                                                    {traveler.givenName[0] ? traveler.givenName[0] + ' ' : ' '}
                                                                    {traveler.middleName[0] ? traveler.middleName[0] + ' ' : ' '}
                                                                    {traveler.surname ? traveler.surname + ' ' : ' '}
                                                                </span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>شماره بلیط</b>
                                                                <span>{traveler.tpaextensions.any[0].eTicket}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>تاریخ تولد</b>
                                                                <span>{traveler.tpaextensions.any[0].birthDate}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                {traveler.document.docType === 5 ?
                                                                    <b>کد ملی</b>
                                                                    :
                                                                    <b>شماره پاسپورت</b>
                                                                }
                                                                <span>{traveler.document.docID}</span>
                                                            </IonCol>
                                                            {traveler.amendment_info === null ?
                                                                ticket.has_amendments ?
                                                                    <IonCol size="12">
                                                                        {!traveler.selected ?
                                                                            <IonButton
                                                                                color="warning" expand="block"
                                                                                onClick={() => amendmentTicketSelectMultiple(traveler, ticket, travelerIndex, index)}
                                                                            >
                                                                                انتخاب
                                                                            </IonButton>
                                                                            :
                                                                            <IonButton
                                                                                color="danger" expand="block"
                                                                                onClick={() => amendmentTicketDeselectMultiple(traveler, ticket, travelerIndex, index)}
                                                                            >
                                                                                لغو انتخاب
                                                                            </IonButton>
                                                                        }
                                                                    </IonCol>
                                                                    :
                                                                    <IonCol size="12">
                                                                        <IonButton color="dark" expand="block" disabled>زمان استرداد گذشته</IonButton>
                                                                    </IonCol>
                                                                :
                                                                <IonCol size="12">
                                                                    {traveler.amendment_info.status === 'r' ?
                                                                        <IonButton color="primary" expand="block" disabled>در حال بررسی استرداد</IonButton>
                                                                        : traveler.amendment_info.status === 'p' ?
                                                                            <IonButton color="danger" expand="block" disabled>پنالتی</IonButton>
                                                                            : traveler.amendment_info.status === 'c' ?
                                                                                <IonButton color="secondary" expand="block" disabled>ارسال شده به واحد مالی</IonButton>
                                                                                : traveler.amendment_info.status === 'd' ?
                                                                                    <IonButton color="success" expand="block" disabled>مبلغ استرداد شده</IonButton>
                                                                                    : traveler.amendment_info.status === 'j' ?
                                                                                        <IonButton color="medium" expand="block" disabled>غیر قابل استرداد</IonButton>
                                                                                        : traveler.amendment_info.status === 'expired' ?
                                                                                            <IonButton color="dark" expand="block" disabled>زمان استرداد گذشته</IonButton>
                                                                                            :
                                                                                            null
                                                                    }
                                                                </IonCol>

                                                            }
                                                        </IonRow>
                                                    </IonGrid>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )
                                }
                            </div>
                            : step === 2 && !state.amendment_all_passengers_has_requested ?
                                <div className="profile-order-amendment-modal-input-container">
                                    {props.data.direction_ind === 'Roundtrip' ?
                                        itineraries.map((ticket: any, index: number) =>
                                            checkViewStep2RowsRoundtrip(ticket) &&
                                            <div key={"index" + index} className="profile-order-amendment-modal-items">
                                                <div className="amendment-info">
                                                    <div>
                                                        {index === 0 ?
                                                            ' پرواز رفت '
                                                            :
                                                            ' پرواز برگشت '
                                                        }
                                                        از
                                                        <span>({ticket.flight.from.code})</span>
                                                        به
                                                        <span>({ticket.flight.to.code})</span>
                                                    </div>
                                                    <div>
                                                        شماره پرواز (ها) :
                                                        <span>
                                                            {ticket.flight.numbers.join()}
                                                        </span>
                                                    </div>
                                                </div>
                                                {ticket.passengers.map((traveler: any, travelerIndex: number) =>
                                                    <div className="amendment-box" key={"index" + travelerIndex}>
                                                        <IonGrid>
                                                            <IonRow>
                                                                <IonCol size="6">
                                                                    <b>نام و نام خانوادگی</b>
                                                                    <span>
                                                                        {traveler.namePrefix[0].length ? traveler.namePrefix[0] + ' ' : ' '}
                                                                        {traveler.givenName[0] ? traveler.givenName[0] + ' ' : ' '}
                                                                        {traveler.middleName[0] ? traveler.middleName[0] + ' ' : ' '}
                                                                        {traveler.surname ? traveler.surname + ' ' : ' '}
                                                                    </span>
                                                                </IonCol>
                                                                <IonCol size="6">
                                                                    <b>شماره بلیط</b>
                                                                    <span>{traveler.tpaextensions.any[0].eTicket}</span>
                                                                </IonCol>
                                                                <IonCol size="6">
                                                                    <b>تاریخ تولد</b>
                                                                    <span>{traveler.tpaextensions.any[0].birthDate}</span>
                                                                </IonCol>
                                                                <IonCol size="6">
                                                                    {traveler.document.docType === 5 ?
                                                                        <b>کد ملی</b>
                                                                        :
                                                                        <b>شماره پاسپورت</b>
                                                                    }
                                                                    <span>{traveler.document.docID}</span>
                                                                </IonCol>
                                                            </IonRow>
                                                        </IonGrid>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                        :
                                        amendmentData.passengers.map((item: any, index: number) =>
                                            <div key={"index" + index} className="profile-order-amendment-modal-items">
                                                <div className="amendment-info">
                                                    <div>
                                                        پرواز رفت
                                                        از
                                                        <span>({item.ticket_info.departureAirport.locationCode})</span>
                                                        به
                                                        <span>({item.ticket_info.arrivalAirport.locationCode})</span>
                                                    </div>
                                                    <div>
                                                        شماره پرواز :
                                                        <span>
                                                            {item.ticket_info.flightNumber}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="amendment-box">
                                                    <IonGrid>
                                                        <IonRow>
                                                            <IonCol size="6">
                                                                <b>نام و نام خانوادگی</b>
                                                                <span>
                                                                    {item.passenger_info.namePrefix[0].length ? item.passenger_info.namePrefix[0] + ' ' : ' '}
                                                                    {item.passenger_info.givenName[0] ? item.passenger_info.givenName[0] + ' ' : ' '}
                                                                    {item.passenger_info.middleName[0] ? item.passenger_info.middleName[0] + ' ' : ' '}
                                                                    {item.passenger_info.surname ? item.passenger_info.surname + ' ' : ' '}
                                                                </span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>شماره بلیط</b>
                                                                <span>{item.passenger_info.tpaextensions.any[0].eTicket}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                <b>تاریخ تولد</b>
                                                                <span>{item.passenger_info.tpaextensions.any[0].birthDate}</span>
                                                            </IonCol>
                                                            <IonCol size="6">
                                                                {item.passenger_info.document.docType === 5 ?
                                                                    <b>کد ملی</b>
                                                                    :
                                                                    <b>شماره پاسپورت</b>
                                                                }
                                                                <span>{item.passenger_info.document.docID}</span>
                                                            </IonCol>
                                                        </IonRow>
                                                    </IonGrid>
                                                </div>
                                            </div>
                                        )}
                                    <form onSubmit={handleSubmit}>
                                        <IonGrid>
                                            <IonRow>
                                                <IonCol size="12">
                                                    <IonLabel>
                                                        جنسیت
                                                    </IonLabel>
                                                    <IonItem lines="none">
                                                        <IonLabel>جنسیت</IonLabel>
                                                        <IonSelect
                                                            value={formData.gender}
                                                            onIonChange={e => setFormData({ ...formData, gender: e.detail.value })}
                                                            mode="md"
                                                            okText="تایید"
                                                            cancelText="لغو"
                                                        >
                                                            <IonSelectOption value="MR">مرد</IonSelectOption>
                                                            <IonSelectOption value="MRS">زن</IonSelectOption>
                                                        </IonSelect>
                                                    </IonItem>
                                                </IonCol>
                                                <IonCol size="6">
                                                    <IonLabel>
                                                        نام صاحب حساب
                                                        {required.first_name.value ? <span className="required">{required.first_name.message}</span> : null}
                                                    </IonLabel>
                                                    <IonInput type="text" name="first_name" value={formData.first_name || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                                </IonCol>
                                                <IonCol size="6">
                                                    <IonLabel>
                                                        نام خانوادگی صاحب حساب
                                                        {required.last_name.value ? <span className="required">{required.last_name.message}</span> : null}
                                                    </IonLabel>
                                                    <IonInput type="text" name="last_name" value={formData.last_name || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                                </IonCol>
                                                <IonCol size="12">
                                                    <IonLabel>
                                                        شماره شبا
                                                        {required.sheba.value ? <span className="required">{required.sheba.message}</span> : null}
                                                    </IonLabel>
                                                    <IonInput type="text" name="sheba" value={formData.sheba || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                                </IonCol>
                                                <IonCol size="12">
                                                    <IonButton type="submit" color="warning" expand="block">
                                                        ارسال درخواست
                                                    </IonButton>
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid>
                                    </form>
                                </div>
                                :
                                null
                        :
                        <Loading />
                    }
                </div>
                <div className="profile-order-amendment-modal-btns">
                    {step === 1 ?
                        <IonButton
                            color="warning" expand="block"
                            onClick={() => setStep(2)}
                            disabled={
                                (amendmentData.passengers.length === 0 && amendmentData.passengers_ids.length === 0) || state.amendment_all_passengers_has_requested ? true : false
                            }
                        >
                            درخواست استرداد

                        </IonButton>
                        :
                        <IonButton
                            color="medium" expand="block" onClick={() => setStep(1)}>
                            بازگشت
                        </IonButton>
                    }
                </div>
            </IonModal>
            <IonButton color={props.type === 'flight' ? 'danger' : 'dark'} expand="block" onClick={() => setState({ ...state, showProfileOrderAmendmentModal: true })} disabled={props.type === 'hotel' ? true : false}>
                {props.type === 'flight' ?
                    'استرداد'
                    :
                    'استرداد ندارد'
                }
            </IonButton>
        </>
    );
};
export default ProfileOrderAmendment;